import { System_instance34rnn1q53nv02 as System_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Clock.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  KeyboardCase_Letters_getInstance25f79mlixgey5 as KeyboardCase_Letters_getInstance,
  KeyboardType_Text_getInstance1pk95izd69yc4 as KeyboardType_Text_getInstance,
  AutoComplete_OneTimeCode_getInstance2jnburz3ronxh as AutoComplete_OneTimeCode_getInstance,
  KeyboardHints3coyq4x1rsbe3 as KeyboardHints,
  Icon1h1pe6893iwt2 as Icon,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_rem14pbkv8p42gid as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { now3ay3meoyffvdk as now } from '../../lightningserver/db/utils.mjs';
import { delayp0o4nsccwai as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveProcess2z4nh4eb606pm as reactiveProcess } from '../../../../../reactive/com/lightningkite/reactive/core/processes.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_nowBySecond() {
  _init_properties_utils_kt__i7zv1b();
  return nowBySecond;
}
var nowBySecond;
var WithTimestampClass;
function WithTimestamp() {
  if (WithTimestampClass === VOID) {
    class $ {
      constructor(value, timestamp) {
        timestamp = timestamp === VOID ? System_instance.now_2cba_k$() : timestamp;
        this.value_1 = value;
        this.timestamp_1 = timestamp;
      }
      toString() {
        return 'WithTimestamp(value=' + toString(this.value_1) + ', timestamp=' + this.timestamp_1.toString() + ')';
      }
      hashCode() {
        var result = this.value_1 == null ? 0 : hashCode(this.value_1);
        result = imul(result, 31) + this.timestamp_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WithTimestamp()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        if (!this.timestamp_1.equals(other.timestamp_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'WithTimestamp');
    WithTimestampClass = $;
  }
  return WithTimestampClass;
}
function withTimestamp(_this__u8e3s4) {
  _init_properties_utils_kt__i7zv1b();
  return new (WithTimestamp())(_this__u8e3s4);
}
function get_oneTimeCodeLetters(_this__u8e3s4) {
  _init_properties_utils_kt__i7zv1b();
  return new (KeyboardHints())(KeyboardCase_Letters_getInstance(), KeyboardType_Text_getInstance(), AutoComplete_OneTimeCode_getInstance(), VOID, false);
}
function get_password(_this__u8e3s4) {
  _init_properties_utils_kt__i7zv1b();
  return new (Icon())(get_rem(1.5), get_rem(1.5), -240, -1200, 1440, 1440, listOf('M80-200v-80h800v80H80Zm46-242-52-30 34-60H40v-60h68l-34-58 52-30 34 58 34-58 52 30-34 58h68v60h-68l34 60-52 30-34-60-34 60Zm320 0-52-30 34-60h-68v-60h68l-34-58 52-30 34 58 34-58 52 30-34 58h68v60h-68l34 60-52 30-34-60-34 60Zm320 0-52-30 34-60h-68v-60h68l-34-58 52-30 34 58 34-58 52 30-34 58h68v60h-68l34 60-52 30-34-60-34 60Z'));
}
function get_pinCode(_this__u8e3s4) {
  _init_properties_utils_kt__i7zv1b();
  return new (Icon())(get_rem(1.5), get_rem(1.5), -240, -1200, 1440, 1440, listOf('M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm100-200h46v-240h-36l-70 50 24 36 36-26v180Zm124 0h156v-40h-94l-2-2q21-20 34.5-34t21.5-22q18-18 27-36t9-38q0-29-22-48.5T458-600q-26 0-47 15t-29 39l40 16q5-13 14.5-20.5T458-558q15 0 24.5 8t9.5 20q0 11-4 20.5T470-486l-32 32-54 54v40Zm296 0q36 0 58-20t22-52q0-18-10-32t-28-22v-2q14-8 22-20.5t8-29.5q0-27-21-44.5T678-600q-25 0-46.5 14.5T604-550l40 16q4-12 13-19t21-7q13 0 21.5 7.5T708-534q0 14-10 22t-26 8h-18v40h20q20 0 31 8t11 22q0 13-11 22.5t-25 9.5q-17 0-26-7.5T638-436l-40 16q7 29 28.5 44.5T680-360ZM160-240h640v-480H160v480Zm0 0v-480 480Z'));
}
function get_security(_this__u8e3s4) {
  _init_properties_utils_kt__i7zv1b();
  return new (Icon())(get_rem(1.5), get_rem(1.5), -240, -1200, 1440, 1440, listOf('M420-360h120l-23-129q20-10 31.5-29t11.5-42q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 23 11.5 42t31.5 29l-23 129Zm60 280q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80Zm0-84q104-33 172-132t68-220v-189l-240-90-240 90v189q0 121 68 220t172 132Zm0-316Z'));
}
function nowBySecond$slambda() {
  return constructCallableReference(($this$reactiveProcess, $completion) => orPromise($completion, function *($completion) {
    while (true) {
      $this$reactiveProcess.emit_kpj8i4_k$(now($this$reactiveProcess));
      yield* delay(1000n, $completion);
    }
    return Unit_instance;
  }), 1);
}
var properties_initialized_utils_kt_wt0odb;
function _init_properties_utils_kt__i7zv1b() {
  if (!properties_initialized_utils_kt_wt0odb) {
    properties_initialized_utils_kt_wt0odb = true;
    nowBySecond = reactiveProcess(VOID, nowBySecond$slambda());
  }
}
//region block: exports
export {
  get_nowBySecond as get_nowBySecond3qpum9s2860iq,
  get_oneTimeCodeLetters as get_oneTimeCodeLetters3t0azo4jzaibk,
  get_password as get_password140spbyj7xd1o,
  get_pinCode as get_pinCode3orz7rl22w2az,
  get_security as get_securityk5vaffknj7i5,
  withTimestamp as withTimestamp3u9863rbtndct,
};
//endregion

//# sourceMappingURL=utils.mjs.map
